// eslint-disable-next-line import/prefer-default-export
export function getPage (state) {
    return state.page;
}

export function getFocusedNode (state) {
    return state.focusedNode;
}

export function getCachedExercise (state) {
    return (exerciseId) => _.find(state.exercisesData, (item) => item.exerciseId === exerciseId);
}

export function findUnsavedExercise (state) {
    return (taskId, userId) => _.find(state.exercisesData, (item) => item.taskId === taskId && item.userId === userId && !item.saved);
}

export function adminPageTitle (state) {
    return state.adminPageTitle;
}

export function getCurrentTheme (state) {
    return state.isLightTheme;
}

export function getEmulateInfo (state) {
    return state.emulateInfo;
}

export function getFavoritesPages (state) {
    return state.favoritesPages;
}
